// Shim for @empowernow/react to satisfy @empowernow/ui imports
// Forward useAuth from the BFF auth package; provide a permissive usePermission
// until native exports are available.
export { useAuth, AuthProvider as EmpowerNowProvider } from '@empowernow/bff-auth-react';

export function usePermission(_resource?: any, _action?: any) {
  // Always allow; @empowernow/ui uses this only for light UI gating.
  return true;
}


